import { EventManagerForGame, GameComponentForGame, GameSituationInfo } from "./implementationTypes";
import { GameSituationBackend } from "./types";

let gameSituation: GameSituationInfo,
  gameSituationBackend: GameSituationBackend,
  eventManager: EventManagerForGame,
  sourcePlayer: string;

export function initialSetup(
  _gameSituation: GameSituationBackend,
  _eventManager?: EventManagerForGame,
  _sourcePlayer?: string,
) {
  if (_gameSituation) {
    gameSituation = _gameSituation;
    gameSituationBackend = _gameSituation;
  }
  if (_eventManager) {
    eventManager = _eventManager;
  }
  if (_sourcePlayer) {
    sourcePlayer = _sourcePlayer;
  }
}

export { gameSituation, gameSituationBackend, eventManager, sourcePlayer };
